import { NgModule } from '@angular/core';
import { APOLLO_OPTIONS } from 'apollo-angular';
import type { ApolloClientOptions } from '@apollo/client/core';
import { ApolloLink, InMemoryCache, split } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';
import { environment } from '../environments/environment';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { setContext } from '@apollo/client/link/context';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';
import { TokenStorageService } from './shared/services/token-storage.service';
import { extractFiles } from 'extract-files';
import { Kind, OperationTypeNode } from 'graphql';


const uri = environment.apiUrl + '/graphql';
const createApollo = (
  httpLink: HttpLink,
  tokenStorageService: TokenStorageService,
): ApolloClientOptions<any> => {
  const auth = setContext((_operation, _context) => {
    const token = tokenStorageService.getToken();

    if (!token) {
      return {};
    } else {
      return {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
          'GraphQL-Preflight': '1',
        }
      };
    }
  });

  const http = ApolloLink.from([auth, httpLink.create({ uri, extractFiles })]);

  const cache = new InMemoryCache();

  let token = tokenStorageService.getToken();

  tokenStorageService.token.subscribe(t => {
    token = t;
  });

  // let activeSocket: any;

  // Create a WebSocket link:
  const wsLink = new GraphQLWsLink(createClient({
    url: environment.apiWsUrl,
    lazy: true,
    keepAlive: 20_000, // ms
    shouldRetry: _ => true,
    retryAttempts : 999999,
    // on: {
    // connected: (socket) => (activeSocket = socket),
    // ping: (received) => {
    //   // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    //   console.log(`ping received=${received.toString()} readyState=${convertReadyState(activeSocket.readyState)}`);
    // },
    // pong: (received) => {
    //   // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    //   console.log(`pong received=${received.toString()} readyState=${convertReadyState(activeSocket.readyState)}`);
    // },
    // },
    connectionParams: () => {
      if (token) {
        return { token: `${token}` };
      }

      return undefined;
    }
  }));

  // const convertReadyState = (state: number) => {
  //   switch (state) {
  //     case WebSocket.OPEN :
  //       return 'OPEN';
  //     case WebSocket.CONNECTING :
  //       return 'CONNECTING';
  //     case WebSocket.CLOSED :
  //       return 'CLOSED';
  //     case WebSocket.CLOSING :
  //       return 'CLOSING';
  //     default :
  //       return 'UNKNOWN';
  //   }

  // };

  // using the ability to split links, you can send data to each link
  // depending on what kind of operation is being sent
  const networkLink = split(
    // split based on operation type
    ({ query }) => {
      const mainDefinition = getMainDefinition(query) ;
      return (
        mainDefinition.kind === Kind.OPERATION_DEFINITION && mainDefinition.operation === OperationTypeNode.SUBSCRIPTION
      );
    },
    wsLink,
    http
  );

  return {
    link : networkLink,
    cache,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
      },
      query: {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
      },
    }
  };
};

@NgModule({
  providers: [{
    provide: APOLLO_OPTIONS,
    useFactory: createApollo,
    deps: [HttpLink, TokenStorageService],
  }]
})
export class GraphQLModule {}
